import {FC} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
        maxWidth: 700,
        margin: '0 auto',
        padding: '25px 30px 0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        boxSizing: 'border-box',
        opacity: 0,
        animation: '$fadeIn 200ms ease-out 150ms forwards',
        ['@media (max-width:610px)']: {
            padding: '25px 10px 0',
        },
    },
    '@keyframes fadeIn': {
        to: {opacity: 1},
    },
    skeleton: {
        backgroundColor: 'rgb(229, 239, 252)',
        maxWidth: '100%',
    },
    backArrow: {
        alignSelf: 'flex-start',
        marginBottom: 15,
    },
    title: {
        borderRadius: 6,
        marginBottom: 12,
    },
    subtitle: {
        borderRadius: 6,
        marginBottom: 30,
    },
    cardGrid: {
        width: '100%',
        display: 'grid',
        justifyContent: 'center',
        gap: 24,
    },
    card: {
        borderRadius: 10,
    },
}));

interface ICardGridSkeletonProps {
    cards?: number;
    cardWidth?: number;
    cardHeight?: number;
}

export const CardGridSkeleton: FC<ICardGridSkeletonProps> = ({cards = 4, cardWidth = 315, cardHeight = 140}) => {
    const classes = useStyles();

    return (
        <div
            className={classes.cardGrid}
            style={{gridTemplateColumns: `repeat(auto-fill, min(100%, ${cardWidth}px))`}}
        >
            {Array.from({length: cards}, (_, index) => (
                <Skeleton
                    key={index}
                    variant="rect"
                    animation="wave"
                    width="100%"
                    height={cardHeight}
                    className={`${classes.card} ${classes.skeleton}`}
                />
            ))}
        </div>
    );
};

interface IPageSkeletonProps extends ICardGridSkeletonProps {
    withHeader?: boolean;
}

const PageSkeleton: FC<IPageSkeletonProps> = ({withHeader = true, ...cardProps}) => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            {withHeader && (
                <>
                    <Skeleton
                        variant="circle"
                        animation="wave"
                        width={24}
                        height={24}
                        className={`${classes.backArrow} ${classes.skeleton}`}
                    />
                    <Skeleton
                        variant="rect"
                        animation="wave"
                        width={260}
                        height={28}
                        className={`${classes.title} ${classes.skeleton}`}
                    />
                    <Skeleton
                        variant="rect"
                        animation="wave"
                        width={340}
                        height={18}
                        className={`${classes.subtitle} ${classes.skeleton}`}
                    />
                </>
            )}
            <CardGridSkeleton {...cardProps}/>
        </div>
    );
};

export default PageSkeleton;
